export default __webpack_public_path__ + "0ba49d0a5b3324080983520910f1f965.png";